export enum ENTITY {
  TEMPLATE = 'template',
  AUDIT = 'audit',
  BIENSEC_AUDIT = 'biensec-audit',
}
